module.exports = __webpack_public_path__ + "static/media/kafka.1acb8e0d.png";